import { PERSIST_HTML_CONTENT, persistHtmlContent, requestHtmlContent } from './actions'

export const initialState = () => ({} as Record<string, string>)

type HtmlContentAction =
  | ReturnType<typeof requestHtmlContent>
  | ReturnType<typeof persistHtmlContent>

export default function htmlContentReducer(state = initialState(), action: HtmlContentAction) {
  switch (action.type) {
    case PERSIST_HTML_CONTENT: {
      const payload = (action as ReturnType<typeof persistHtmlContent>).payload
      return {
        ...state,
        [payload.key]: payload.content,
      }
    }

    default:
      return state
  }
}
